<template>
  <v-dialog scrollable persistent v-model="dialog">
    <v-card width="90vw">

      <v-card-text>

        <v-card-title style="margin-left:-15px">Add Table Note for Stock Zero Item</v-card-title>

        <v-textarea variant="outlined" height="20" :placeholder="'Note'" v-model="note"></v-textarea>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn style="background:gray;color:white" @click="$emit('close')">CANCEL</v-btn>
        <v-btn style="background:#ff7214;color:white" @click="saveNote()" :disabled="submitted_by.trim() === '' || note.trim() === ''">SAVE</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase/compat/app';
import { mapGetters, mapActions } from 'vuex'
import Moment from 'moment'
import _ from 'lodash'

export default {
  name: 'NotePurchaseOrderPopUp',
  components: {},
  mixins: [],
  props:{
    itemkey: String
  },
  data(){
    return{
      dialog: true,
      note: '',
      submitted_by: ''
    }
  },
  beforeMount(){
    if(this.user){
      this.submitted_by = this.db.users[this.user].email
    }
  },
  computed: {
    ...mapGetters(['user','db']),
  },
  methods:{
    saveNote(){
      var self = this
      self.$store.state.isLoading = true
      firebase.database().ref('stock_zero').child(self.itemkey.stock_zero_id).child('table_note').child(self.itemkey.po_item_key).push({note: self.note, submitted_by: self.submitted_by, submitted_date: Date.now()})
      setTimeout(() => {
        self.$store.state.isLoading = false
        self.$emit('close')
      }, 2000);      
    }
  }
}
</script>

<style>

</style>


